import React from 'react'
import cl from './../index.module.scss'
import { FoodItem } from '../FoodItem'
import { Food } from '../../../../core/db_food'
import { searchFoodRegexp } from '../../../../hooks/useFood'
import { ActionButtons } from '../../../../component/ActionButtons'
import { SimpleButton } from '../../../../component/Form/Button/SimpleButton'
import { AddButton } from '../../../../component/ActionButtons/RoundButton'

type PanelFoodsProps = {
    foods: Food[]
    search: string
    onAddAll: () => void
}
export const PanelFoods: React.FC<PanelFoodsProps> = ({ foods, search, onAddAll }) => {
    return (
        <>
            <div className={cl.foods__items}>
                {
                    filterFoods(foods, search).map(food => {
                        return <FoodItem key={food.dt + ' ' + food.name}
                            mode={'click'}
                            isSelected={false}
                            food={{ f: food, lf: undefined }}
                            search={search} click={() => {}} />
                    })
                }
            </div>
            {
                search.length == 0 ? (
                    <ActionButtons zIndex={15}>
                        <div style={{ padding: 8,
                            pointerEvents: 'auto',
                            userSelect: 'none' }}>
                            {/* <AddButton onClick={onAddAll} disabled={false}/> */}
                            <SimpleButton type='light-success' click={onAddAll} disabled={false}>Добавить все</SimpleButton>
                        </div>
                    </ActionButtons>
                ) : undefined
            }
        </>
    )
}

function filterFoods(foods: Food[], search: string): Food[] {
    return foods.filter(food => searchFoodRegexp(search).test(food.name))
}